const config = [
  { propName: 'filters', reducerName: 'filters' },
  { propName: 'isDataLoading', reducerName: 'isLoading' },
  { propName: 'sort', reducerName: 'sort' },
  { propName: 'searchTerm', reducerName: 'searchTerm' },
  { propName: 'currentProject', reducerName: 'currentProject' },
  { propName: 'page', reducerName: 'page' },
  { propName: 'statusFilter', reducerName: 'statusFilter' },
  {
    propName: 'currentProjectProspects',
    reducerName: 'currentProjectProspects',
  },
  { propName: 'removeAction', reducerName: 'removeAction' },
  { propName: 'createReview', reducerName: 'createReview' },
  { propName: 'addAction', reducerName: 'addAction' },
  { propName: 'projectStats', reducerName: 'projectStats' },
  { propName: 'notInFlow', reducerName: 'notInFlow' },
  { propName: 'notInAnyFlow', reducerName: 'notInAnyFlow' },
  { propName: 'projectLimitedData', reducerName: 'projectLimitedData' },
];

// Function to dynamically generate project selectors
export const getProjectDetails = (state) => {
  const projectDetails = {};

  config.forEach(({ propName, reducerName }) => {
    projectDetails[propName] = state?.projectDetails?.[reducerName];
  });

  return projectDetails;
};
